import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { BetaSignupForm } from "./BetaSignupForm";
import { CheckCircle } from "lucide-react";

interface BetaSignupDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function BetaSignupDialog({ open, onOpenChange }: BetaSignupDialogProps) {
  const [success, setSuccess] = useState(false);

  const handleSuccess = () => {
    setSuccess(true);
    setTimeout(() => {
      onOpenChange(false);
      // Reset success state after closing
      setTimeout(() => setSuccess(false), 300);
    }, 3000);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] p-0">
        <ScrollArea className="max-h-[90vh]">
          <div className="p-6">
            <DialogHeader>
              <DialogTitle>Join the Beta Program</DialogTitle>
              <DialogDescription>
                Sign up for early access to ComplyManager and help shape the future of IT/OT compliance management.
              </DialogDescription>
            </DialogHeader>

            {success ? (
              <div className="flex flex-col items-center justify-center py-12 text-center">
                <CheckCircle className="h-16 w-16 text-green-500 mb-4" />
                <h3 className="text-xl font-semibold mb-2">Thank You!</h3>
                <p className="text-muted-foreground max-w-md">
                  Your application has been received. We'll review your information and get back to you shortly with next steps.
                </p>
              </div>
            ) : (
              <div className="mt-6">
                <BetaSignupForm onSuccess={handleSuccess} />
              </div>
            )}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
